import { render, staticRenderFns } from "./BankAccountsTable.vue?vue&type=template&id=7cef2e01"
import script from "./BankAccountsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BankAccountsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports